const V = "lw.savedValues";
const L = "lw.savedLists";
const read = (k, d) => { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; } };
const write = (k, v) => localStorage.setItem(k, JSON.stringify(v));

export const FILL_LABELS = ["Name / Company", "Address 1", "Address 2", "Postal code", "Country", "Contact number", "Email address"];

export const savedValues = () => read(V, {});
export const addValue = (label, value) => {
  const v = value.trim();
  if (!v) return false;
  const all = savedValues();
  const list = all[label] || [];
  if (list.includes(v)) return false;
  write(V, { ...all, [label]: [...list, v] });
  return true;
};
export const removeValue = (label, value) => {
  const all = savedValues();
  const list = (all[label] || []).filter((x) => x !== value);
  if (list.length) all[label] = list; else delete all[label];
  write(V, all);
};

export const savedLists = () => read(L, []);
export const saveList = (name, options) => write(L, [...savedLists().filter((l) => l.name !== name), { name, options }]);
export const removeList = (name) => write(L, savedLists().filter((l) => l.name !== name));
